<div class="title">
  <nb-icon icon="layers" pack="eva"></nb-icon>
  <span [nbTooltip]="scan().name">
      {{ scan().name }}
    </span>
</div>
<div class="manage">
  @if (canEdit()) {
    <button nbButton status="basic" size="small" [nbTooltip]="'Scan bearbeiten'" (click)="editScan.emit(scan())">
      <nb-icon icon="edit-outline" pack="eva"></nb-icon>
    </button>
  }
  @if (canDelete()) {
    <button nbButton status="basic" size="small" [nbTooltip]="'Scan löschen'" (click)="deleteScan.emit(scan())">
      <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
    </button>
  }
</div>
<div class="type">{{ scan().type | scanType }}</div>
<div class="sections">
  @for (section of scan().sections; track section.id) {
    <span class="section-label">{{ section.address }}</span>
  }
</div>
<div class="date">{{ scan().createdAt | date: 'dd.MM.yyyy' }}</div>
<div class="actions">
  <a nbButton status="primary" size="small" [routerLink]="routerLink()" [nbTooltip]="'Zum Scan wechseln'">
    <nb-icon icon="arrow-forward-outline" pack="eva"></nb-icon>
  </a>
</div>
